import { UPDATE_CLIENT_ROLE, UPDATE_CLIENT_ROLE_SUCCESS, UPDATE_CLIENT_ROLE_ERROR, UPDATE_CLIENT_ROLE_EMPTY } from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const UpdateClientRole = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_CLIENT_ROLE:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case UPDATE_CLIENT_ROLE_SUCCESS:
      state = {
        ...state,
        data: action?.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };

      break;

    case UPDATE_CLIENT_ROLE_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case UPDATE_CLIENT_ROLE_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default UpdateClientRole;
